import { useNavigate } from "react-router-dom";

export default function Forbidden() {
    const navigate = useNavigate();

    return (
        <div style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "#f9fafb",
            fontFamily: "system-ui, sans-serif",
            padding: "20px",
            textAlign: "center"
        }}>
            <div style={{
                background: "white",
                padding: "48px",
                borderRadius: "24px",
                boxShadow: "0 20px 50px rgba(0,0,0,0.05)",
                maxWidth: "500px"
            }}>
                <div style={{
                    fontSize: "64px",
                    marginBottom: "16px"
                }}>🚫</div>
                <h1 style={{
                    fontSize: "28px",
                    fontWeight: "800",
                    margin: "0 0 12px 0",
                    color: "#111827"
                }}>Access Restricted</h1>
                <p style={{
                    fontSize: "16px",
                    color: "#4b5563",
                    lineHeight: "1.6",
                    margin: "0 0 32px 0"
                }}>
                    This module is not enabled for your organization or industry type. Please contact your administrator if you believe this is an error.
                </p>
                <div style={{ display: "flex", gap: "12px", justifyContent: "center" }}>
                    <button 
                        onClick={() => navigate("/dashboard")}
                        style={{
                            background: "#4f46e5",
                            color: "white",
                            border: "none",
                            padding: "12px 24px",
                            borderRadius: "12px",
                            fontWeight: "600",
                            cursor: "pointer",
                            transition: "background 0.2s"
                        }}
                    >
                        Go to Dashboard
                    </button>
                    <button 
                        onClick={() => navigate(-1)}
                        style={{
                            background: "transparent",
                            color: "#4b5563",
                            border: "1px solid #d1d5db",
                            padding: "12px 24px",
                            borderRadius: "12px",
                            fontWeight: "600",
                            cursor: "pointer"
                        }}
                    >
                        Go Back
                    </button>
                </div>
            </div>
        </div>
    );
}
